'use client';

import Image from 'next/image';
import * as React from "react";
import { Menu, Xmark } from "iconoir-react";
import {
  IconButton,
  Typography,
  Collapse,
  Navbar,
} from "@material-tailwind/react";

const LINKS = [
  {
    title: "Home",
    href: "/",
    color: "",
  },
  {
    title: "About",
    href: "/about",
    color: "",
  },
  {
    title: "Gallery",
    href: "/gallery",
    color: "",
  },
  {
    title: "Contact",
    href: "/contact",
    color: ""
  },
  {
    title: "Book",
    href: "/home2#trip-calendar",
    color: "lg:bg-green-900"
  },
];

function NavList() {
  return (
    <ul className="m-2 flex flex-col gap-x-3 gap-y-1 lg:m-0 lg:flex-row lg:items-center">
      {LINKS.map(({ title, href, color }) => (
        <li key={title} className={`flex pt-3 pb-3 pl-6 pr-6 text-center rounded-md hover:bg-green-600  transition-colors duration-300 ease-in-out delay-75 ${ (color !== "" && color) }`}>
          <Typography
            as="a"
            href={href}
            type="small"
            className="w-full"
          >
            {title}
          </Typography>
        </li>
      ))}
    </ul>
  );
}

export default function NavBar() {
  const [openNav, setOpenNav] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false),
    );
  }, []);

  return (
    <Navbar className="pl-5 pr-5 mx-auto w-full max-w-screen-xl bg-opacity-0">
      <div className="flex items-center">
        <Image 
          src="/silvertrail-logo.png"
          width={1024}
          height={1024}
          alt="Silver Trail logo"
          className="w-12 ml-2 mt-1"
          onClick={() => window.location.href = '/'}
        />
        <Typography
          as="a"
          href="/"
          type="h2"
          className="mx-2 py-1 font-semibold text-3xl"
        >
          Silver Trail Cabin
        </Typography>
        <div className="hidden lg:ml-auto lg:mr-2 lg:block">
          <NavList />
        </div>
        <IconButton
          size="sm"
          variant="ghost"
          color="secondary"
          onClick={() => setOpenNav(!openNav)}
          className="ml-auto grid lg:hidden pr-2"
        >
          {openNav ? (
            <Xmark className="h-4 w-4" />
          ) : (
            <Menu className="h-4 w-4" />
          )}
        </IconButton>
      </div>
      <Collapse open={openNav}>
        <NavList />
      </Collapse>
    </Navbar>
  );
}
